module.exports = require("pino");